import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import "./index.css";
import App from "./App";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";
import store from './services/store';

theme.typography.h1 = {
  fontSize: "2rem",
  [theme.breakpoints.up("md")]: {
    fontSize: "3rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "4rem",
  },
};
theme.typography.h2 = {
  fontWeight: 500,
  [theme.breakpoints.up("md")]: {
    fontSize: "36px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "2.5rem",
  },
};
theme.typography.h3 = {
  fontSize: "1rem",
  [theme.breakpoints.up("md")]: {
    fontSize: "1.5rem",
  },
  // [theme.breakpoints.up("lg")]: {
  //   fontSize: "24px",
  // },
};
theme.typography.h4 = {
  lineHeight: 1.5,
  fontWeight: 500,
  [theme.breakpoints.down("md")]: {},
  [theme.breakpoints.up("md")]: {},
  [theme.breakpoints.up("lg")]: {},
};
theme.typography.h6 = {
  fontWeight: 500,
  [theme.breakpoints.up("md")]: {
    fontSize: "1rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "20px",
  },
};

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
